import { LinearProgress } from '@material-ui/core';
import AppBar from '@material-ui/core/AppBar/AppBar';
import Toolbar from '@material-ui/core/Toolbar/Toolbar';
import * as React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import LOGO from "../assets/labour_logo_white.svg";
import { AuthContext } from '../auth-context';
import { Content } from '../components/content';
import { TokenServiceClient } from '../model/autogen/TokenController';
import { RoutePaths } from '../route-paths';
import { SnackbarContext } from '../snackbar-context';

export class ExternalSignIn extends React.Component<RouteComponentProps<any>, any> {
    render() {
        return <SnackbarContext.Consumer>
            {({ methods: { showMessage } }) => {
                return <AuthContext.Consumer>
                    {({ methods: { setToken } }) => {
                        return <>
                            <AppBar position="static" color="primary">
                                <Toolbar>
                                    <div><img style={{ height: '50px', marginLeft: '-20px' }} className="app-logo-nzl-fern" src={LOGO} /></div>
                                </Toolbar>
                            </AppBar>
                            <Content>
                                <LinearProgress />
                                <ExternalSignInTokenRetriever setToken={setToken} history={this.props.history} showMessage={showMessage} />
                            </Content>
                        </>;
                    }}
                </AuthContext.Consumer>
            }}
        </SnackbarContext.Consumer>;
    }
}

class ExternalSignInTokenRetriever extends React.Component<any, any> {
    public async componentDidMount() {
        // call the API to retrieve a token if it exists
        var token = await TokenServiceClient.externalLogin();
        if (token && token.token) {
            this.props.setToken(token);
            this.props.history.push(RoutePaths.Home);
            return;
        }
        this.props.showMessage("Your login was denied. You may not have access to this database.");
        this.props.history.push(RoutePaths.SignIn);
    }
    public render() {
        return <h1>Retrieving login details...</h1>;
    }
}


// WEBPACK FOOTER //
// ./src/pages/external-sign-in-page.tsx